import script from "./FAQPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FAQPage.vue?vue&type=script&setup=true&lang=ts"

import "./FAQPage.vue?vue&type=style&index=0&id=9d01cbb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d01cbb2"]])

export default __exports__